(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["current-discounts"] && !Shopify.designMode) return;
  try {
    
  class DiscountCountdown extends HTMLElement {
    connectedCallback() {
      const endDate = this.dataset.endDate;
      if (!endDate) return;

      this.#update();
      this._timer = window.setInterval(() => this.#update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this._timer);
    }

    #update() {
      const end = Date.parse(this.dataset.endDate);
      if (Number.isNaN(end)) {
        this.hidden = true;
        return;
      }

      const remaining = end - Date.now();
      if (remaining <= 0) {
        this.hidden = true;
        window.clearInterval(this._timer);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.#setUnit('days', days);
      this.#setUnit('hours', hours);
      this.#setUnit('minutes', minutes);
      this.#setUnit('seconds', seconds);
    }

    #setUnit(unit, value) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (el) el.textContent = String(value).padStart(2, '0');
    }
  }

  if (!customElements.get('discount-countdown')) {
    customElements.define('discount-countdown', DiscountCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarouselPosters {
    /** @type {IntersectionObserver | null} */
    static #observer = null;

    static init() {
      const images = document.querySelectorAll('.video-carousel img[data-vimeo-id]');
      if (!images.length) return;

      if (!VideoCarouselPosters.#observer) {
        VideoCarouselPosters.#observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const img = entry.target;
              if (!(img instanceof HTMLImageElement)) return;
              VideoCarouselPosters.#observer?.unobserve(img);
              VideoCarouselPosters.#loadPoster(img);
            });
          },
          { rootMargin: '240px' }
        );
      }

      images.forEach((img) => {
        if (img.dataset.vimeoPosterQueued) return;
        img.dataset.vimeoPosterQueued = 'true';
        VideoCarouselPosters.#observer?.observe(img);
      });
    }

    /**
     * @param {HTMLImageElement} img
     */
    static async #loadPoster(img) {
      const id = img.dataset.vimeoId;
      if (!id) return;

      try {
        const oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${id}`)}&width=800`;
        const response = await fetch(oembedUrl);
        if (!response.ok) return;

        const data = await response.json();
        if (!data.thumbnail_url) return;

        img.src = data.thumbnail_url;
        img.width = data.thumbnail_width;
        img.height = data.thumbnail_height;
        img.removeAttribute('data-vimeo-id');
      } catch {
        /* keep placeholder if oembed is unavailable */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => VideoCarouselPosters.init());
  } else {
    VideoCarouselPosters.init();
  }

  document.addEventListener('shopify:section:load', () => VideoCarouselPosters.init());

  } catch(e) { console.error(e); }
})();
})();
